import theme from '@styles/theme';
export default {
  section: {
    backgroundColor: theme.rawColors.lightGrey300,
    padding: ['32px 16px', '32px 16px', '48px 24px', '64px 40px']
  },
  container: {
    maxWidth: '1200px',
    margin: '0 auto',
    display: 'flex',
    flexDirection: ['column', 'column', 'row'],
    gap: ['32px', '32px', '40px', '64px'],
    alignItems: ['stretch', 'stretch', 'flex-start']
  },
  infoColumn: {
    flex: 1,
    minWidth: 0
  },
  title: {
    marginBottom: '16px'
  },
  description: {
    fontFamily: theme.fonts.uniform,
    fontSize: theme.fontSizes.text,
    lineHeight: '150%',
    color: theme.rawColors.darkGrey700,
    margin: 0,
    p: {
      margin: 0
    }
  },
  formCard: {
    display: 'flex',
    flexDirection: 'column',
    gap: '0px',
    flex: 1,
    width: ['100%', '100%', '100%', 'fit-content'],
    maxWidth: '100%',
    flexShrink: 0,
    backgroundColor: theme.rawColors.neutralWhite,
    padding: ['24px 20px', '24px 20px', '32px 28px', '80px 80px'],
    boxShadow: '0 4px 24px rgba(0, 0, 0, 0.06)'
  },
  formTitle: {
    textTransform: 'capitalize',
    marginBottom: '24px',
    fontFamily: `${theme.fonts.uniformMedium} !important`
  },
  inputContainer: {
    marginBottom: '16px'
  },
  customerPanelLink: {
    display: 'inline-block',
    marginBottom: '32px',
    marginTop: '-4px',
    fontFamily: theme.fonts.uniform,
    fontSize: theme.fontSizes.text,
    color: theme.rawColors.darkGrey700,
    textDecoration: 'underline'
  },
  errorMessage: {
    marginBottom: '16px',
    fontFamily: theme.fonts.uniform,
    fontSize: theme.fontSizes.caption,
    color: theme.rawColors.accent700
  },
  submitButton: {
    width: '100%',
    maxWidth: '240px',
    height: '40px',
    span: {
      fontFamily: `${theme.fonts.uniformMedium} !important`,
      fontSize: theme.fontSizes.text,
      fontStyle: 'normal',
      lineHeight: '140%',
      letterSpacing: '1.6px'
    }
  }
};